import { render, staticRenderFns } from "./carDetail.vue?vue&type=template&id=7cf2b86a&scoped=true"
import script from "./carDetail.vue?vue&type=script&lang=js"
export * from "./carDetail.vue?vue&type=script&lang=js"
import style0 from "./carDetail.vue?vue&type=style&index=0&id=7cf2b86a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cf2b86a",
  null
  
)

export default component.exports